// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetEstimationHistoryByDealTypeWebRequest,
  TGetEstimationHistoryByDealTypeWebModel,
  IMappers,
  TGetEstimationHistoryByDealTypeWebResponse,
  IGetEstimationHistoryByDealTypeWebResponse,
  IGetEstimationHistoryByDealTypeWebResponseError,
} from './types';

export const defaultConfig: TGetEstimationHistoryByDealTypeWebModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'price-estimator',
  pathApi: '/v1/get-estimation-history-by-deal-type-web/',
  requestType: 'json',
} as TGetEstimationHistoryByDealTypeWebModel;

export function createGetEstimationHistoryByDealTypeWebModel(
  parameters: IGetEstimationHistoryByDealTypeWebRequest,
): TGetEstimationHistoryByDealTypeWebModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetEstimationHistoryByDealTypeWebOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetEstimationHistoryByDealTypeWebRequest;
}

export async function fetchGetEstimationHistoryByDealTypeWeb<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetEstimationHistoryByDealTypeWebOptions<TResponse200, TResponse400>): Promise<
  TGetEstimationHistoryByDealTypeWebResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetEstimationHistoryByDealTypeWebModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetEstimationHistoryByDealTypeWebResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetEstimationHistoryByDealTypeWebResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetEstimationHistoryByDealTypeWebResponse;
}
